import React, { useMemo } from 'react';
import { PointStatus, pointType } from '../../../constants/types/mypage-type';
import TextWinds from '../../../components/common/TextWinds';
import { numberWithCommas } from '../../../api/utils/format/numbers';
import { Link } from 'react-router-dom';

const DESCRIPTION_ADMIN_MANUAL_DEPOSIT = '관리자 수동 지급';
const DESCRIPTION_ADMIN_MANUAL_DEDUCTION = '관리자 차감';

interface PointItemProps {
  data: pointType;
}

const PointItem = ({ data }: PointItemProps) => {
  const fontColor = data.amount < 0 ? 'text-gray7' : 'text-purple5';
  const canceledStyle =
    data.status === PointStatus.CANCELED ? 'line-through' : '';

  /**
   * description 파싱 로직
   * - DESCRIPTION_ADMIN_MANUAL_DEPOSIT: 관리자 수동 지급 으로 일괄 치환. adminNote 추가 이전에 description을 메모 처럼 사용하던 시기의 문구들을 파싱해야해서 남김
   * - DESCRIPTION_ADMIN_MANUAL_DEDUCTION: 관리자 차감 으로 일괄 치환. adminNote 추가 이전에 description을 메모 처럼 사용하던 시기의 문구들을 파싱해야해서 남김
   * - 그 외: 그대로 반환
   */
  const description = useMemo(() => {
    if (data.description.includes(DESCRIPTION_ADMIN_MANUAL_DEPOSIT)) {
      return DESCRIPTION_ADMIN_MANUAL_DEPOSIT;
    } else if (data.description.includes(DESCRIPTION_ADMIN_MANUAL_DEDUCTION)) {
      return DESCRIPTION_ADMIN_MANUAL_DEDUCTION;
    } else {
      return data.description;
    }
  }, [data.description]);

  return (
    <div className="flex flex-col gap-y-1 border-b py-2">
      <div className="flex justify-between gap-y-2">
        <TextWinds type="content_body4" color="gray5">
          {data.registerAt?.toString().slice(0, 10)}
        </TextWinds>
        <div className="text-xs text-gray5">
          {data.expiryAt ? (
            <>유효기간 {data.expiryAt?.toString().slice(0, 10)} 까지</>
          ) : null}
        </div>
      </div>
      <div className={`flex justify-between ${canceledStyle}`}>
        <div className={`font-semibold ${fontColor}`}>{description}</div>

        <div className={`flex items-center gap-x-1 ${fontColor}`}>
          {numberWithCommas(data.amount)}점{' '}
        </div>
      </div>
      <div>
        {data.relatedOrderId ? (
          <Link
            to={`/mypage/purchase/detail/${data.relatedOrderId}`}
            className="text-sm text-gray7 hover:text-purple5"
          >
            구매정보 {'>'}
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default PointItem;
